module.exports = function() {
  return new Worker(__webpack_public_path__ + "d5ad0823fc244e0f9727.worker.js");
};